import { useTranslation } from 'react-i18next';
import { AuditLogsAgGridWrapper, PageHeader } from '@circuitry-ai/doc-ui';

function AuditLogs() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full min-h-0">
      <PageHeader
        heading={t('Audit Logs')}
        description={t('Track activity events across your workspace')}
        pageHeaderClass="pb-6 !px-0 !gap-1"
      />
      <AuditLogsAgGridWrapper />
    </div>
  );
}

export default AuditLogs;
